'use strict';

export function showAlert(options) {
    if (!options) { options = {}; }
    if (!options.title) { options.title = 'equisoft Live';}
    if (!options.body) { options.body = '';}

    var htmlcontent = '<div class="genericPopup">';
    htmlcontent += '<img class="infomationPopupImage" src="img/info.svg" style="width: 50px;">';
    htmlcontent += '<div class="informationText">';
    htmlcontent += '<p>' + options.body + '</p>';
    htmlcontent += '</div>';
    htmlcontent += '</div>';
    htmlcontent += '<a id="popOkButton" class="jq_button">Ok</a>';

    // change exising to promise
    return new Promise((resolve) => {

        function onShowAlertClose() {
            // Add new callback option
            if (typeof options.callback === 'function') {
                options.callback();
            }

            resolve(); // Resolve the promise
        }

        popWin({
            popID: 'genericCardPop',
            title: options.title,
            classes: 'genericCardPop',
            noAutoWidth: false,
            modal: true,
            zIndex: 5000,
            contents: htmlcontent,
            hideCloseButton: false,
            onClose: function(){
                onShowAlertClose();
            },
            loadComplete: function () {
                $('.jq_button').button();

                $('#popOkButton').click(() => {
                    popWinClose('genericCardPop');
                    onShowAlertClose();
                });

            },
        });
    });

}